import AresDescription from "../../../../src/courses/partials/services/ares.mdx";
import * as React from 'react';
export default {
  AresDescription,
  React
};